module.exports = __webpack_public_path__ + "static/img/bg1.1fccf88.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/bg1.jpg
// module id = sL66
// module chunks = 1